import { Component, Input, OnInit } from '@angular/core';
import { TypeAlert } from '@pacifico/types/types-model-components';
import { DialogRef } from '../modal-side/models/modal-ref';
import { Subject, timer, Subscription, interval } from 'rxjs';
import { WarningAlertModal } from '@pacifico/utils/enums';

@Component({
	selector: 'app-modal-alert-regresive',
	templateUrl: './modal-alert-regresive.component.html',
	styleUrls: ['./modal-alert-regresive.component.scss']
})
export class ModalAlertRegresiveComponent implements OnInit {
	@Input() type: TypeAlert = 'warn';
	@Input() message = '';
	@Input() title = '';
	@Input() showButtonCancel = true;
	@Input() autoClose = false;
	@Input() showButtonClose = true;
	@Input() textFirstButton = 'Deshacer';
	@Input() textSecondButton = 'Cancelar';
	source$ = interval(1000);
	timerSoruce$ = timer(6000);
	time = 5;
	private _timerInvervalsub = new Subscription();
	private _timersub = new Subscription();
	constructor(private dialogRef: DialogRef) {}

	ngOnInit(): void {
		//pantalla mobile
		if (window.innerWidth <= 600) {
			window.scroll(0, 200);
		} else {
			window.scroll(0, 0);
		}
		document.getElementsByTagName('body')[0].classList.add('mostrar_detalle');
		/** espera 5 segundos y oculta  */
		this._timerInvervalsub = this.source$.subscribe(() => {
			this.time -= 1;
			console.log('time', this.time);
			if (this.time === 0) {
				console.log('aceptando');
				this.clickAcept();
			}
		});
		this._timersub = this.timerSoruce$.subscribe(() => {
			console.log('desuscribiendo');
			this._timerInvervalsub.unsubscribe();
		});
	}

	private readonly _onClose = new Subject<unknown>();
	public onClose = this._onClose.asObservable();

	clickAcept(): void {
		document.getElementsByTagName('body')[0].classList.remove('mostrar_detalle');
		this._timerInvervalsub.unsubscribe();
		this._timersub.unsubscribe();
		this.dialogRef.close(WarningAlertModal.ACCEPT);
	}

	clickCancel(): void {
		document.getElementsByTagName('body')[0].classList.remove('mostrar_detalle');
		this._timerInvervalsub.unsubscribe();
		this._timersub.unsubscribe();
		this.dialogRef.close(WarningAlertModal.CANCEL);
	}

	getClassType(): string {
		switch (this.type) {
			case 'info':
				return 'modal_info';
			case 'error':
				return 'modal_error';
			case 'succes':
				return 'modal_exito';
			default:
				return 'modal_advertencia';
		}
	}
}
